import { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import "../../Assets/css/Sidebar.css";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeKey, setActiveKey] = useState("dashboard");

  // Sync activeKey with current route
  useEffect(() => {
    const pathParts = location.pathname.split("/");
    // assuming route is /admin/:tab
    setActiveKey(pathParts[2] || "dashboard");
  }, [location]);

  const handleSelect = (key) => {
    setActiveKey(key);
    navigate(`/admin/${key}`); // navigate on tab click
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    navigate("/auth/login");
  };

  return (
    <div className="sidebar-container">
      {/* Top Logo */}
      <div className="logo px-3 pt-3">
        BioME.com
      </div>

      {/* Center Nav Tabs */}
      <Nav
        className="flex-column sidebar-nav px-3"
        activeKey={activeKey}
        onSelect={handleSelect}
      >
        <Nav.Link eventKey="dashboard">Dashboard</Nav.Link>
        <Nav.Link eventKey="user">Users</Nav.Link>
      </Nav>

      {/* Bottom Logout */}
      <div className="sidebar-logout">
        <button className="btn btn-danger w-100" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
